// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1869":"f5f0bcd215eaa5d4","4367":"8e3d5bf08531bdee"}[chunkId] + ".css";
};